export default __webpack_public_path__ + "static/media/kaptankadir2.fe81b842.jpg";